/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CSondage } from './CSondage';
import { Fichier } from './Fichier';
import { Lov } from './Lov';
import { CSondageReponse } from './CSondageReponse';
import { CSondageReponseUsers } from './CSondageReponseUsers';

export enum CSondageQuestionType {
  SINGLE,
  MULTIPLE,
  TEXT,
}

export interface CSondageQuestion {
  id: number;
  cSondageId: number;
  lovIdEtat: number;
  lovIdType: number;
  fichierIdImage: number;
  titre: string;
  texte: string;
  requis: boolean;
  ordre: number;
  type: CSondageQuestionType;
  cSondage: CSondage;
  fichierIdImageNavigation: Fichier;
  lovIdEtatNavigation: Lov;
  lovIdTypeNavigation: Lov;
  cSondageReponse: CSondageReponse[];
  cSondageReponseUsers: CSondageReponseUsers[];
}
